export default {
    REDO: "Вернуть"
};
